<div class="dialog-content-wrapper">
    <mat-toolbar matDialogTitle class="mat-accent m-0">
        <mat-toolbar-row fxLayout="row" fxLayoutAlign="space-between center">
            <span class="title dialog-title">Potwierdź udział</span>
            <button mat-icon-button (click)="matDialogRef.close()" aria-label="Close dialog">
                <mat-icon>close</mat-icon>
            </button>
        </mat-toolbar-row>
    </mat-toolbar>

    <div mat-dialog-content class="p-24 pb-0 m-0" fusePerfectScrollbar>
        Czy potwierdzasz udział klienta <b>{{data.firstName}} {{data.lastName}}</b> w treningu?
    </div>

    <div mat-dialog-actions class="m-0 p-16" fxLayout="row" fxLayoutAlign="end center">

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close({status: 'cancel'})"
                aria-label="OK"
                matTooltip="OK">
            Nie
        </button>

        <button
                mat-button
                class="mr-8"
                (click)="matDialogRef.close({status: 'confirm'})"
                aria-label="OK"
                matTooltip="OK">
            Tak
        </button>

    </div>
</div>
